<template>
    <div class="Item" :class="[{ 'enable': enable }, {'locked': locked }, { 'small': small }]"  @click="onClick(asset)">
        <img class="Item__hidden" :src="require('../img/assets/hidden_'+ lang +'.png')" :class="[{ 'small': small }]" v-if="hidden"/> 
        <img :src="require('../img/'+ categorie + '/thumbnail/'+ asset +'.png')" />    
    </div>
</template>
<script>

export default {
    name: 'Assets',
    props: ['categorie', 'asset', 'enable', 'small'],
    data: ()=>({
        locked: false,
        hidden: false,
        stickers: [ 'clothing_10', 'beachball', 'balloons', 'confetti', 'paintsplatter', 'butterflies', 'crown', 'flowers', 'hat', 'spoon', 'clothing_08', 'flower', 'glasses_02', 'facialhair_03', 'clothing_01', 'clothing_02', 'clothing_13', 'bird', 'clothing_12', 'horse', 'hair_07', 'clothing_11', 'cat', 'necklace', 'clothing_03', 'tie']
    }),
    created() {   
        const is_sticker = _.indexOf(this.stickers, this.asset)
        const finded = _.indexOf(this.stickers_finded, this.asset)
        if(is_sticker > -1 && finded == -1) {
            this.hidden = true
            this.locked = true
        }
    },
    computed: { 
        stickers_finded() { return this.$store.getters['app/stickers_finded'] },
    },
    methods: {
        onClick(asset) {
            if(this.locked)
                return
            this.$store.commit('app/SET_AMBIANCE', 'selection')
            this.$store.commit('app/SET_PORTRAIT', { categorie: this.categorie, value: asset })
        },
    },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Item 
    cursor pointer
    width 155px
    height 206px    
    margin 0px 8px 8px 0
    border 2px solid transparent
    background rgba(255, 255, 255, .1)
    position relative

    & img 
        width 100%

    &.small
        height 155px

    &.enable 
       border 2px solid white 

    &.locked
        pointer-events none

    &__hidden 
        position absolute
        top 0
        width 220px !important

        &.small
            top -24px
       
</style>































































// WEBPACK FOOTER //
// src/components/defis/components/Item.vue